// extracted by mini-css-extract-plugin
export default {"pageContainer":"MPArticlePage_pageContainer__KxtDv"};